export default "__VITE_ASSET__BcI2i9tY__"